import { inject, InjectionToken } from '@angular/core'
import { Router } from '@angular/router'

import { QueryParams } from 'app/static/query-params.enum'

export const SHOW_TRANSLATION_KEYS = new InjectionToken<boolean>(ngDevMode ? 'SHOW_TRANSLATION_KEYS' : '', {
  providedIn: 'root',
  factory: () => {
    const router = inject(Router)
    return router.parseUrl(router.url).queryParams[QueryParams.SHOW_I18N_KEYS] === 'true'
  },
})
